export default __webpack_public_path__ + "static/media/tek-bond.7cc45b7f.png";